/**
 * @generated SignedSource<<4bfd123e76097a0f6a7dfa3c951697db>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type tabs_AtlassianSearchPage$data = {
  readonly tabs: ReadonlyArray<{
    readonly tabId: string | null;
    readonly title: string | null;
    readonly url: string | null;
  }> | null;
  readonly " $fragmentType": "tabs_AtlassianSearchPage";
};
export type tabs_AtlassianSearchPage$key = {
  readonly " $data"?: tabs_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"tabs_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "tabs_AtlassianSearchPage",
  "selections": [
    {
      "concreteType": "SearchResultGraphTab",
      "kind": "LinkedField",
      "name": "tabs",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "tabId"
        },
        {
          "kind": "ScalarField",
          "name": "title"
        },
        {
          "kind": "ScalarField",
          "name": "url"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};

(node as any).hash = "c02ba04c211b1a64b9312215c94994e6";

export default node;
